<template>
<div class='my-2 py-2'>
  
  <b-row class="my-4">
    <b-col sm="3" md="3" lg="3">
      <b-img rounded fluid :src="dataset.thumbnailURL">
      </b-img>
    </b-col>

    <b-col class="bg-light">
      <b-row>
        <span class="dbb-red"><h3><i>{{ dataset.datasetTitle }}</i></h3></span>
      </b-row>
      <b-row class="my-3" v-for="(contentSection, sectionIndex) in dataset.datasetContentList" :key="sectionIndex">
        <b-col>
          <h4>{{ contentSection.title }}</h4>
          <li v-html="contentItem" class="larger-font" v-for="(contentItem, itemIndex) in contentSection.content" :key="itemIndex">
            
          </li>
        </b-col>
      </b-row>

      <b-row>
        <p class="mx-3"> {{ dataset.datasetContentFooter }} </p>
      </b-row>
      
      <b-row class="text-center my-4">
        <b-button 
          :to="'/tileviewer/' + dataset.id" 
          class="btn-red mx-auto my-2" 
          size="lg">
          <b-icon icon="eye"></b-icon> View
        </b-button>

        <!-- <b-button @click="downloadPublication" class="btn-red mx-auto" size="lg" :disabled="dataset.publication == ''">
          <b-icon icon="file-earmark-text"></b-icon> Information
        </b-button> -->

        <b-button 
          class="btn-red mx-auto my-2" 
          size="lg" 
          :to="'/info/' + dataset.id"
          :disabled="dataset.download_data == ''">
          <b-icon icon="info-circle"></b-icon> Information
        </b-button>

        <b-button 
          class="btn-red mx-auto my-2" 
          size="lg" 
          v-b-modal="modalIDPreview()" 
          :disabled="dataset.download_data == ''"
          v-if="dataset.previewFiles.length > 0">
          <b-icon icon="download"></b-icon> Preview Data
        </b-button>

        <b-button 
          class="btn-red mx-auto my-2" 
          size="lg" 
          v-if="dataset.requiresMTA === true"
          :href="`mailto:${dataset.correspondingAuthorEmail}`">
          <b-icon icon="envelope"></b-icon> Request Data
        </b-button>

        <b-button 
          class="btn-red mx-auto my-2" 
          size="lg" 
          v-b-modal="modalIDDownload()" 
          :disabled="dataset.download_data == ''"
          v-if="dataset.requiresMTA === false && dataset.downloadableFiles.length > 0">
          <b-icon icon="download"></b-icon> Download Data
        </b-button>

      </b-row>
    </b-col>
  </b-row>

  <b-modal :id="modalIDDownload()" :title="dataset.datasetTitle +  ' (Downloads)'" hide-footer>
    <p 
      v-for="(dlitem, dlindex) in dataset.downloadableFiles"
      :key="dlindex"
      
    >
       <b-link href="" @click="downloadFile(dlitem.url)">
        {{ dlitem.name }} 
      </b-link>
    </p>
  </b-modal>

  <b-modal :id="modalIDPreview()" :title="dataset.datasetTitle +  ' (Downloads)'" hide-footer>
    <p 
      v-for="(pritem, prindex) in dataset.previewFiles"
      :key="prindex"
      
    >
       <b-link href="" @click="downloadFile(pritem.url)">
        {{ pritem.name }} 
      </b-link>
    </p>
  </b-modal>

</div>
  
</template>

<script>
// a dataset is an entry from the digital brain bank database.
// a dataset appears as a row on each of the brain bank dataset pages.

//import * as dbblib from "@/dbblib.js"
// import axios from 'axios'
import anchorme from "anchorme"

export default {
  name: 'dataset',
  props: {
    "dataset": Object,
  },
  data () {
    return {
      viewerUrl: '',
      // thumbnailUrl: dbblib.makeThumbnailUrl(this.datasetID),
      // publicationUrl: dbblib.makePublicationUrl(this.datasetID),
      downloadFileList: [],
    }
  },
  
  methods: {
    modalIDPreview() {
      return 'preview-files-modal' + this.dataset.id
    },
    modalIDDownload() {
      return 'donwload-files-modal' + this.dataset.id
    },
    downloadPublication() {

      // dbblib.getPublication(this.datasetID)
      // .then(res => res.blob() )
      // .then(blob => {
      //   var file = window.URL.createObjectURL(blob)
      //   var a = document.createElement('a')
      //   document.body.appendChild(a)
      //   a.style = 'display: none'
      //   a.href = file
      //   a.download = "publication"

      //   a.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}))
      //   document.body.removeChild(a)
      // })
    },
    
    downloadFile(url) {

      // dbblib.getDownloadableFile(id, dl_item)
      // .then(res => {
      //   console.log(res)
        window.location.assign(url);
      //   /*var file = window.URL.createObjectURL(blob)
      //   var a = document.createElement('a')
      //   document.body.appendChild(a)
      //   a.style = 'display: none'
      //   a.href = file
      //   a.download = dl_item

      //   a.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}))
      //   document.body.removeChild(a)
      //   */
      // })
    },
    getDataset() {
      // dbblib.getDataset(this.datasetID)
      // .then(response => response.json()) 
      // .then(json_data => this.dataset= json_data.payload)

    },
    makeViewerUrl () {

        // this.viewerUrl = dbblib.makeViewerUrl(this.datasetID)// '#/tileviewer' //`#/tileviewer/${this.kind}/${this.projects[i].id}/${this.projects[i].tiles}/${this.projects[i].min_zoom}/${this.projects[i].max_zoom}`
        // console.log(this.viewerUrl)
      },

    makeDownloadFileList() {
      //this.downloadFileList = []
      // var fileList = dbblib.fileListFromString(this.dataset.download_data)
      // for (var i=0; i < fileList.length; i++) {
      //   this.downloadFileList.push(
      //     {
      //       fileName: fileList[i],
      //       fileUrl: dbblib.makeDownloadUrl(this.datasetID, fileList[i])
      //     }
      //   )
      // }
    },

    showDownloadModal() {
      // this.$bvModal.show('download-files-modal' + this.datasetID.toString())
    }
  },
  watch: {
    // dataset: {
    //   deep: true,
    //   handler() {
    //     this.makeViewerUrl()
    //     this.makeDownloadFileList()
    //   }

  },
  mounted () {
    this.getDataset()
    console.log(this.dataset)
    for (var i=0; i<this.dataset.datasetContentList.length; i++) {
      var contentSection = this.dataset.datasetContentList[i]

      for (var j=0; j<contentSection.content.length; j++){
        var content = contentSection.content[j]
        this.dataset.datasetContentList[i].content[j] = anchorme({
          input: content,
        })
      }
    }
  }
  
}
</script>

<style scoped>
.dbb-red {
  color: #8b2a34;
}

.btn-red {
  background-color: #8b2a34;
  border-color: #8b2a34;
}

.larger-font {
  font-size: 16px;
}
</style>
